import {SET_COMPS_ERROR, SET_COMPS_LOADED, SET_COMPS_LOADING} from 'constants/actionTypes'
import {propertyAggregationApi} from 'services/apis'
import type {AppDispatch} from 'services/store'
import type {GetCompsResponse} from 'types/propertyTypes'

export function getCompsByPid(pid: string) {
  return (dispatch: AppDispatch) => {
    dispatch({type: SET_COMPS_LOADING})
    return propertyAggregationApi
      .get<GetCompsResponse>(`property/${pid}/comps`)
      .then(res => {
        dispatch({
          type: SET_COMPS_LOADED,
          payload: {comps: res, subjectPid: pid}
        })
      })
      .catch(err => {
        dispatch({
          type: SET_COMPS_ERROR,
          payload: err
        })
      })
  }
}
